export default __webpack_public_path__ + "static/media/(23).dc0a08fb.jpg";